import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./reset.scss";
import "./global.scss";
import App from "./App";

const container = document.getElementById("root");

if (!container) {
  throw new Error("Elemento raiz da aplicação não encontrado.");
}

const root = createRoot(container);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
